import React, { useEffect, useState } from "react";
import "./Status.css";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Tooltip,
  Stack,
  Alert,
  IconButton,
} from "@mui/material";
import * as Mui from "@mui/material";
import {
  House,
  ImportantDevices,
  Smartphone,
  PersonOff,
  Fingerprint,
  ShareLocation,
} from "@mui/icons-material";
import { showToast } from "services/utils/Status";
import { Loader } from "components/Loader";
import { useSelector } from "react-redux";
import { themes } from "services/constants";
import { getStatusColor } from "services/utils/Status";
import { useDispatch } from "react-redux";
import sessionHandling from "services/utils/notificationUtils";
import { tooltipStyleProps } from "services/constants/Styles";

export const AllStatus = ({ date, departmentid, setDeviceOffline }) => {
  const dispatch = useDispatch();
  const [expandedCards, setExpandedCards] = useState({});
  const [showIcons, setShowIcons] = useState(true);
  const [intervalTime, setIntervalTime] = useState(200);
  const { token, domain, globalSearchValue, userDetails } = useSelector(
    (state) => state.tokenReducer
  );
  let allStatus = useSelector((state) => state.leaveReducer.allStatus);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState([]);
  const [masterDataForSearch, setMasterDataForSearch] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${domain}checkinfilter/?date=${date}&department_id=${departmentid}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          if (response.status === 202) {
            setDeviceOffline(true);
          } else {
            if (res?.user_status_details) {
              const user_data = res?.user_status_details?.filter(
                (item) => item?.user_id === userDetails?.id
              );
              setData(user_data);
              setMasterDataForSearch(user_data);
            }
          }
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [
    token,
    date,
    domain,
    departmentid,
    dispatch,
    allStatus,
    setDeviceOffline,
    userDetails?.id,
  ]);

  useEffect(() => {
    const FilterDockets = () => {
      const cols =
        masterDataForSearch[0] && Object.keys(masterDataForSearch[0]);
      return masterDataForSearch.filter((r) =>
        cols.some((c) =>
          r[c]
            ? r[c]
                .toString()
                .toLowerCase()
                .indexOf(globalSearchValue.toLowerCase()) > -1
            : null
        )
      );
    };
    setData(FilterDockets());
  }, [globalSearchValue, masterDataForSearch]);

  const handleCardClick = (cardId) => {
    setExpandedCards((prevState) => ({
      [cardId]: !prevState[cardId],
    }));
  };
  useEffect(() => {
    const interval = setInterval(() => {
      setShowIcons(!showIcons);
      setIntervalTime(200);
    }, intervalTime);
    return () => {
      clearInterval(interval);
    };
  }, [intervalTime, showIcons]);

  const statusBasedIcons = (status, locationStatus) => {
    switch (status) {
      case "Home":
        return (
          <Tooltip arrow slotProps={tooltipStyleProps} title="Home">
            <IconButton
              onMouseOver={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(100000000);
                  setShowIcons(false);
                }
              }}
              onMouseOut={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(2000);
                }
              }}
            >
              <House
                style={{
                  fontSize: "large",
                  color:
                    locationStatus === "Pending" || locationStatus === "Hold"
                      ? "red"
                      : themes.activeTap,
                }}
              />
            </IconButton>
          </Tooltip>
        );
      case "Office":
        return (
          <Tooltip arrow slotProps={tooltipStyleProps} title="Office">
            <IconButton
              size="small"
              onMouseOver={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(100000000);
                  setShowIcons(false);
                }
              }}
              onMouseOut={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(500);
                }
              }}
            >
              <ImportantDevices
                style={{
                  fontSize: "large",
                  color:
                    locationStatus === "Pending" || locationStatus === "Hold"
                      ? "red"
                      : themes.activeTap,
                }}
              />
            </IconButton>
          </Tooltip>
        );
      case "Site":
        return (
          <Tooltip arrow slotProps={tooltipStyleProps} title="Site">
            <IconButton
              size="small"
              onMouseOver={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(100000000);
                  setShowIcons(false);
                }
              }}
              onMouseOut={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(500);
                }
              }}
            >
              <Smartphone
                style={{
                  fontSize: "large",
                  color:
                    locationStatus === "Pending" || locationStatus === "Hold"
                      ? "red"
                      : themes.activeTap,
                }}
              />
            </IconButton>
          </Tooltip>
        );
      case "Tracking":
        return (
          <Tooltip arrow slotProps={tooltipStyleProps} title="Tracking">
            <IconButton
              onMouseOver={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(100000000);
                  setShowIcons(false);
                }
              }}
              onMouseOut={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(2000);
                }
              }}
            >
              <ShareLocation
                style={{
                  fontSize: "large",
                  color:
                    locationStatus === "Pending" || locationStatus === "Hold"
                      ? "red"
                      : themes.activeTap,
                }}
              />
            </IconButton>
          </Tooltip>
        );
      case "Biometric":
        return (
          <Tooltip arrow slotProps={tooltipStyleProps} title="Biometric">
            <IconButton
              onMouseOver={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(100000000);
                  setShowIcons(false);
                }
              }}
              onMouseOut={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(2000);
                }
              }}
            >
              <Fingerprint
                style={{
                  fontSize: "large",
                  color:
                    locationStatus === "Pending" || locationStatus === "Hold"
                      ? "red"
                      : themes.activeTap,
                }}
              />
            </IconButton>
          </Tooltip>
        );
      case "None":
        return (
          <Tooltip arrow slotProps={tooltipStyleProps} title="-">
            <IconButton
              onMouseOver={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(100000000);
                  setShowIcons(false);
                }
              }}
              onMouseOut={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(2000);
                }
              }}
            >
              <PersonOff
                style={{
                  fontSize: "large",
                  color: "red",
                }}
              />
            </IconButton>
          </Tooltip>
        );
      default:
        return "";
    }
  };

  return (
    <React.Fragment>
      {loading ? (
        <Loader info="Loading..." />
      ) : data.length === 0 ? (
        <Mui.Grid xs={11.8} sx={{ mt: 5 }}>
          <Mui.Alert severity="info">
            {masterDataForSearch?.length === 0
              ? "No data available."
              : "No matching data found for your search."}
          </Mui.Alert>
        </Mui.Grid>
      ) : (
        <Grid container spacing={0} sx={{ justifyContent: "center" }}>
          {data.length > 0 ? (
            <>
              {data.map(
                (item, index) =>
                  item.user_id && (
                    <Grid item key={item.id}>
                      <Card
                        className=" max-w-fit mt-5 w-96 flex space-x-1 shadow-lg  "
                        variant="outlined"
                        sx={{
                          borderRadius: 2,
                          marginLeft: 3,
                          marginTop: 5,
                          backgroundColor:
                            item.current_location_status === "Pending" ||
                            item.current_location_status === "Hold"
                              ? themes.backgroundShadow
                              : themes.whiteColor,
                        }}
                        onClick={() => handleCardClick(item.id)}
                      >
                        <CardContent>
                          <Mui.Grid container>
                            <Mui.Grid item xs={2.5}>
                              <Mui.Avatar
                                sx={{
                                  width: 40,
                                  height: 40,
                                  backgroundColor: "#ff4d88",
                                }}
                                alt={item.user_name?.charAt(0).toUpperCase()}
                                src={item.image_url}
                              />
                            </Mui.Grid>
                            <Mui.Grid
                              item
                              xs={9.5}
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-start",
                                alignItems: "flex-start",
                              }}
                            >
                              <Mui.Stack>
                                <Mui.Typography
                                  fontWeight={"bold"}
                                  sx={{
                                    fontSize:
                                      item.user_name.length < 15
                                        ? "18px"
                                        : "15px",
                                  }}
                                >
                                  {item.user_name
                                    ? item.user_name.length >= 15
                                      ? item.user_name.substr(0, 15) + "..."
                                      : item.user_name
                                    : "N/A"}
                                </Mui.Typography>
                                <Mui.Grid container>
                                  <Mui.Grid
                                    item
                                    xs={item.type === "Week Off" ? 9.5 : 10}
                                  >
                                    <Mui.Typography>
                                      {item?.user_code
                                        ? item.user_code
                                            .toString()
                                            .padStart(6, "0")
                                        : "N/A"}
                                    </Mui.Typography>
                                  </Mui.Grid>
                                  <Mui.Grid
                                    item
                                    xs={item.type === "Week Off" ? 2.5 : 2}
                                  >
                                    <Mui.Tooltip
                                      arrow
                                      slotProps={tooltipStyleProps}
                                      title={
                                        item.type === "Missing"
                                          ? item.reason || ""
                                          : ""
                                      }
                                      disableHoverListener={
                                        item.type !== "Missing"
                                      }
                                      cursor="pointer"
                                    >
                                      <Mui.Box
                                        name="status"
                                        sx={{
                                          width:
                                            item.type === "Week Off" ? 90 : 80,
                                          height: 15,
                                          backgroundColor: getStatusColor(
                                            item.type
                                          ),
                                          borderRadius: "16px",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          p: 2,
                                          fontSize: 13,
                                          color:
                                            item.type === "Week Off"
                                              ? themes?.headLine
                                              : themes.whiteColor,
                                          border:
                                            item.type === "Week Off"
                                              ? "1px solid black"
                                              : "none",
                                          cursor:
                                            item.type === "Missing"
                                              ? "pointer"
                                              : "default",
                                        }}
                                      >
                                        {item.type}
                                      </Mui.Box>
                                    </Mui.Tooltip>
                                  </Mui.Grid>
                                </Mui.Grid>
                              </Mui.Stack>
                            </Mui.Grid>
                            <Mui.Grid item xs={3}></Mui.Grid>
                            <Mui.Grid item xs={0.5}></Mui.Grid>
                          </Mui.Grid>
                          <div className="mt-2 ">
                            <Grid item xs={6} sx={{ marginTop: 1 }}>
                              <Typography
                                sx={{ color: themes.primaryIndicator }}
                                fontSize={18}
                              >
                                Check-In
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              xs={6}
                              sx={{ marginTop: -3.5, marginLeft: 20 }}
                            >
                              <Typography
                                sx={{ color: themes.primaryIndicator }}
                                fontSize={18}
                              >
                                Check-Out
                              </Typography>
                            </Grid>
                            <Grid container spacing={2}>
                              <Grid item xs={6}>
                                <Typography sx={{ mt: 0 }} fontSize={16}>
                                  {item.check_in_time_formatted &&
                                  item.check_in_time_formatted !== "null"
                                    ? item.check_in_time_formatted
                                    : "N/A"}
                                </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography sx={{ mt: 0, ml: 4 }} fontSize={16}>
                                  {item.check_out_time_formatted &&
                                  item.check_out_time_formatted !== "null"
                                    ? item.check_out_time_formatted
                                    : "N/A"}
                                </Typography>
                              </Grid>
                            </Grid>
                          </div>
                          {expandedCards[item.id] && (
                            <>
                              {item?.ot_allowed && (
                                <Mui.Grid>
                                  <Stack direction="row">
                                    <Grid container>
                                      <Grid
                                        item
                                        xs={4}
                                        sx={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "flex-start",
                                          alignItems: "flex-start",
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            color: themes.primaryIndicator,
                                          }}
                                          fontSize={15}
                                        >
                                          Ot Start
                                        </Typography>
                                      </Grid>
                                      <Grid
                                        item
                                        xs={4}
                                        sx={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "flex-center",
                                          alignItems: "flex-center",
                                          paddingLeft: 0.5,
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            color: themes.primaryIndicator,
                                          }}
                                          fontSize={15}
                                        >
                                          Ot End
                                        </Typography>
                                      </Grid>
                                      <Grid
                                        item
                                        xs={4}
                                        sx={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "flex-end",
                                          alignItems: "flex-end",
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            color: themes.primaryIndicator,
                                          }}
                                          fontSize={15}
                                        >
                                          Total-Time
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Stack>
                                  {item.overtime_details.length === 0 ? (
                                    <Stack
                                      direction="row"
                                      spacing={2}
                                      sx={{ paddingLeft: 0, paddingTop: -2 }}
                                    >
                                      <Grid item xs={4}>
                                        <Typography fontSize={15}>
                                          N/A
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={4}>
                                        <Typography fontSize={15}>
                                          N/A
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={4}>
                                        <Typography fontSize={15}>
                                          N/A
                                        </Typography>
                                      </Grid>
                                    </Stack>
                                  ) : (
                                    item.overtime_details.map(
                                      (breakDetail, index) => (
                                        <Stack
                                          direction="row"
                                          spacing={2}
                                          sx={{ paddingLeft: 0 }}
                                        >
                                          <Grid item xs={4}>
                                            <Typography sx={{ fontSize: 14 }}>
                                              {breakDetail?.ot_start_formatted
                                                ? breakDetail?.ot_start_formatted
                                                : "N/A"}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={4}>
                                            <Typography
                                              sx={{
                                                fontSize: 14,
                                                paddingLeft: 0.4,
                                              }}
                                            >
                                              {breakDetail?.ot_end_formatted
                                                ? breakDetail?.ot_end_formatted
                                                : "N/A"}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={4}>
                                            <Typography
                                              sx={{
                                                fontSize: 14,
                                                paddingLeft: 1.5,
                                              }}
                                            >
                                              {breakDetail.individual_ot_time &&
                                              breakDetail.individual_ot_time !==
                                                "null"
                                                ? breakDetail.individual_ot_time
                                                : "N/A"}
                                            </Typography>
                                          </Grid>
                                        </Stack>
                                      )
                                    )
                                  )}
                                </Mui.Grid>
                              )}
                              <Stack direction="row">
                                <Grid container>
                                  <Grid
                                    item
                                    xs={4}
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "flex-start",
                                      alignItems: "flex-start",
                                    }}
                                  >
                                    <Typography
                                      sx={{ color: themes.primaryIndicator }}
                                      fontSize={15}
                                    >
                                      Break Start
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={4}
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "flex-center",
                                      alignItems: "flex-center",
                                      paddingLeft: 0.5,
                                    }}
                                  >
                                    <Typography
                                      sx={{ color: themes.primaryIndicator }}
                                      fontSize={15}
                                    >
                                      Break End
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={4}
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "flex-end",
                                      alignItems: "flex-end",
                                    }}
                                  >
                                    <Typography
                                      sx={{ color: themes.primaryIndicator }}
                                      fontSize={15}
                                    >
                                      Total-Time
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Stack>
                              {item.break_details.length === 0 ? (
                                <Stack
                                  direction="row"
                                  spacing={2}
                                  sx={{ paddingLeft: 0, paddingTop: -2 }}
                                >
                                  <Grid item xs={4}>
                                    <Typography fontSize={15}>N/A</Typography>
                                  </Grid>
                                  <Grid item xs={4}>
                                    <Typography fontSize={15}>N/A</Typography>
                                  </Grid>
                                  <Grid item xs={4}>
                                    <Typography fontSize={15}>N/A</Typography>
                                  </Grid>
                                </Stack>
                              ) : (
                                item.break_details.map((breakDetail, index) => (
                                  <Stack
                                    direction="row"
                                    spacing={2}
                                    sx={{ paddingLeft: 0 }}
                                  >
                                    <Grid item xs={4}>
                                      <Typography sx={{ fontSize: 14 }}>
                                        {breakDetail?.break_out_formatted
                                          ? breakDetail?.break_out_formatted
                                          : "N/A"}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Typography
                                        sx={{
                                          fontSize: 14,
                                          paddingLeft: 0.4,
                                        }}
                                      >
                                        {breakDetail?.break_in_formatted
                                          ? breakDetail?.break_in_formatted
                                          : "N/A"}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Typography
                                        sx={{
                                          fontSize: 14,
                                          paddingLeft: 1.5,
                                        }}
                                      >
                                        {breakDetail.individual_break_time &&
                                        breakDetail.individual_break_time !==
                                          "null"
                                          ? breakDetail.individual_break_time
                                          : "N/A"}
                                      </Typography>
                                    </Grid>
                                  </Stack>
                                ))
                              )}

                              <Stack direction="row" sx={{ paddingTop: 1 }}>
                                <Grid xs={9}>
                                  <Typography
                                    sx={{ color: themes.primaryIndicator }}
                                    fontSize={18}
                                  >
                                    Total Break Hours
                                  </Typography>
                                </Grid>
                                <Grid xs={1}>:</Grid>
                                <Grid xs={2}>
                                  <Typography>
                                    {item.total_break_time === "" ||
                                    item.total_break_time === "00:00"
                                      ? "N/A"
                                      : item.total_break_time}
                                  </Typography>
                                </Grid>
                              </Stack>
                            </>
                          )}
                          <Mui.Stack direction="row" sx={{ paddingTop: 0.5 }}>
                            <Mui.Grid xs={9}>
                              <Mui.Typography
                                sx={{ color: themes.primaryIndicator }}
                                fontSize={17}
                              >
                                Total OverTime Hours
                              </Mui.Typography>
                            </Mui.Grid>
                            <Mui.Grid xs={1}>:</Mui.Grid>
                            <Mui.Grid xs={2}>
                              <Mui.Typography>
                                {item?.total_over_time
                                  ? item?.total_over_time
                                  : "N/A"}
                              </Mui.Typography>
                            </Mui.Grid>
                          </Mui.Stack>
                          <Stack direction="row" sx={{ paddingTop: 0.5 }}>
                            <Grid xs={9}>
                              <Typography
                                sx={{ color: themes.primaryIndicator }}
                                fontSize={18}
                              >
                                Total Working Hours
                              </Typography>
                            </Grid>
                            <Grid xs={1}>:</Grid>
                            <Grid xs={2}>
                              <Typography>
                                {item.total_work_time === "" ||
                                item.total_work_time === "00:00"
                                  ? "N/A"
                                  : item.total_work_time}
                              </Typography>
                            </Grid>
                          </Stack>
                          <div style={{ paddingTop: 15 }}>
                            <Mui.Grid container>
                              <Mui.Grid item xs={6}>
                                <Mui.Typography
                                  fontSize={15}
                                  fontWeight={"bold"}
                                  sx={{
                                    paddingBottom: 1.5,
                                    color: themes.primaryIndicator,
                                  }}
                                >
                                  Shift Name
                                </Mui.Typography>
                                <Mui.Tooltip
                                  arrow
                                  slotProps={tooltipStyleProps}
                                  title={item.shift_name}
                                >
                                  <Mui.Typography>
                                    {item.shift_name
                                      ? item.shift_name.length >= 12
                                        ? item.shift_name.substr(0, 12) + "..."
                                        : item.shift_name
                                      : "N/A"}
                                  </Mui.Typography>
                                </Mui.Tooltip>
                              </Mui.Grid>
                              <Mui.Grid
                                item
                                xs={6}
                                sx={{
                                  marginTop: 0,
                                  justifyContent: "flex-end",
                                }}
                              >
                                <div
                                  style={{
                                    justifyContent: "flex-end",
                                    display:
                                      item.current_location_status ===
                                        "Pending" ||
                                      item.current_location_status === "Hold"
                                        ? showIcons
                                          ? "none"
                                          : "flex"
                                        : "flex",
                                  }}
                                >
                                  {statusBasedIcons(
                                    item.current_location_tag,
                                    item.current_location_status
                                  )}
                                </div>
                                {item.current_location_name === "-" ? (
                                  <Mui.Tooltip
                                    arrow
                                    slotProps={tooltipStyleProps}
                                    title={item.current_location_name}
                                  >
                                    <Mui.Typography
                                      sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "flex-end",
                                        alignItems: "flex-end",
                                        paddingTop: 1,
                                        paddingRight: 2,
                                      }}
                                    >
                                      {item.current_location_name
                                        ? item.current_location_name.length >=
                                          10
                                          ? item.current_location_name.substr(
                                              0,
                                              10
                                            ) + "..."
                                          : item.current_location_name
                                        : "N/A"}
                                    </Mui.Typography>
                                  </Mui.Tooltip>
                                ) : (
                                  <Mui.Tooltip
                                    arrow
                                    slotProps={tooltipStyleProps}
                                    title={item.current_location_name}
                                  >
                                    <Mui.Typography
                                      sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "flex-end",
                                        alignItems: "flex-end",
                                        paddingTop: 1,
                                        fontSize: 15,
                                      }}
                                    >
                                      {item.current_location_name
                                        ? item.current_location_name.length >=
                                          10
                                          ? item.current_location_name.substr(
                                              0,
                                              10
                                            ) + "..."
                                          : item.current_location_name
                                        : "N/A"}
                                    </Mui.Typography>
                                  </Mui.Tooltip>
                                )}
                              </Mui.Grid>
                            </Mui.Grid>
                          </div>
                        </CardContent>
                      </Card>
                    </Grid>
                  )
              )}
            </>
          ) : (
            <Alert sx={{ marginTop: 5 }} severity="info">
              No data available
            </Alert>
          )}
        </Grid>
      )}
    </React.Fragment>
  );
};
